import React from 'react'
import {TablesWidget10} from '../../../_websoft/partials/widgets'

const PlanProizvodnje = () => {
  return <TablesWidget10 className={'plan-proizvodnje'} isPage={true} />
}

export default PlanProizvodnje
